export const GET_MENU_PRODUCT_DYNAMIC_DATA_LIST_SUCCESS = 'GET_MENU_PRODUCT_DYNAMIC_DATA_LIST_SUCCESS';
export const UPDATE_MENU_PRODUCT_DYNAMIC_DATA_LIST_SUCCESS = 'UPDATE_MENU_PRODUCT_DYNAMIC_DATA_LIST_SUCCESS';
export const APPLY_MENU_PRODUCT_DYNAMIC_DATA_LIST_CHANGES = 'APPLY_MENU_PRODUCT_DYNAMIC_DATA_LIST_CHANGES';
